import Vue from 'vue';

export default Vue.mixin({
  computed: {
    $device() {
      return {
        isMobile: this.$mq === 'sm' || this.$mq === 'xs',
        isTablet: this.$mq === 'md',
        isDesktop: this.$mq === 'lg' || this.$mq === 'xl',
      };
    },
  },
});
